import React from 'react';

import { AppFormField, AppFormFieldProps } from '../appFormField';

import { ToggleComponentWrapper } from './toggleWrapper.component';

export class ToggleFieldComponent extends AppFormField {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    const { input, meta, label, ...rest } = field;

    return <ToggleComponentWrapper {...input} {...rest} isAppFormField />;
  }
}
